import { makeVar } from "@apollo/client";

const user = JSON.parse(localStorage.getItem("cus-rib-user"));

const userVar = makeVar(user);

export default userVar;
